module.exports = __webpack_public_path__ + "static/img/dsh1-2.7b046e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingDetail/dsh1-2.png
// module id = 2t+S
// module chunks = 0